export default "__VITE_ASSET__eDzD0E5___";